export default __webpack_public_path__ + "static/media/exponent.9e447fc7.svg";